import { type ArticleDto, type ArticleTagDto } from "@modules/article/gateway/articleApiDto"
import { SanityService } from "@modules/common/cms/sanityService"
import { type SanityContentBlock, type SanityThumbnailImage } from "@modules/common/cms/sanityType"

export class Article {
  public readonly _id: string
  public readonly _type: "article"
  public readonly _rev: string
  public readonly _createdAt: string
  public readonly _updatedAt: string
  public readonly title: string
  public readonly description: string
  public readonly author: string
  public readonly thumbnail: SanityThumbnailImage
  public readonly tag: ArticleTagDto
  public readonly content: SanityContentBlock
  public readonly seo_id: {
    current: string
    _type: string
  }

  constructor(articleDto: ArticleDto) {
    this._id = articleDto._id
    this._type = articleDto._type
    this._rev = articleDto._rev
    this._createdAt = articleDto._createdAt
    this._updatedAt = articleDto._updatedAt
    this.title = articleDto.title
    this.description = articleDto.description
    this.author = articleDto.author
    this.thumbnail = {
      _type: articleDto.thumbnail._type,
      _key: articleDto.thumbnail._key,
      alt_text: articleDto.thumbnail.alt_text,
      uri: SanityService.buildImageUri(articleDto.thumbnail),
    }
    this.tag = articleDto.tag
    this.content = SanityService.buildContentBlock(articleDto.content)
    this.seo_id = articleDto.seo_id
  }
}
